import { render } from "./ContractModelUpdate.vue?vue&type=template&id=2f71e336&scoped=true"
import script from "./ContractModelUpdate.vue?vue&type=script&lang=js"
export * from "./ContractModelUpdate.vue?vue&type=script&lang=js"

import "./ContractModelUpdate.vue?vue&type=style&index=0&id=2f71e336&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f71e336"]])

export default __exports__